import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Thesis from './pages/Thesis';
import Portfolio from './pages/Portfolio';
import Team from './pages/Team';
import Contact from './pages/Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem('ls_gate') === 'open');

  if (!unlocked) {
    return (
      <Landing onUnlock={() => {
        sessionStorage.setItem('ls_gate', 'open');
        setUnlocked(true);
      }} />
    );
  }

  return (
    <>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thesis" element={<Thesis />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
}
